<template>
  <div class="letter-jacket-package-image">
    <div class="row">
      <div class="col-xs-12 col-sm-10 col-sm-offset-1">
        <div class="product__main-img-wrapper product__main-img-wrapper--no-img-selection product__main-img-wrapper--border">
          <img
            :src="packageImageUrl"
            class="responsive-img"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LetterJacketPackageImage',
  props: {
    packageImageUrl: { type: String, default: null, required: true }
  }
}
</script>

<style>
.letter-jacket-package-image {
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/LetterJacketPackageImage.vue